import { RefObject, useEffect } from 'react';

type SetCustomCursor = {
  cursorType: string;
  shouldSetCursor: boolean;
  ref: RefObject<HTMLElement>;
};

const useSetCustomCursor = (params: SetCustomCursor) => {
  useEffect(() => {
    const { shouldSetCursor, cursorType, ref } = params;

    if (ref.current) {
      ref.current.style.cursor =
        shouldSetCursor && cursorType ? cursorType : 'auto';
    }

    return () => {
      if (ref.current) {
        ref.current.style.cursor = 'auto';
      }
    };
  }, [params]);
};

export default useSetCustomCursor;
